import React, { useEffect } from "react";

import style from "./styles.module.scss";

export interface SnackbarProps {
  message: string | null;
  duration?: number;
  onClose(): void;
}

export default function Snackbar({ message, duration = 4000, onClose }: SnackbarProps) {
  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timer = window.setTimeout(onClose, duration);
    return () => window.clearTimeout(timer);
  }, [message, duration, onClose]);

  return (
    <div className={style.region} role="status" aria-live="polite">
      {message && (
        <div className={style.snackbar}>
          <span className={`pgm-body-medium ${style.message}`}>{message}</span>
        </div>
      )}
    </div>
  );
}
